import React from 'react';
import './timer.css';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Timer = props => {
    const { timeElapsed, maxTime, orientation, countUp } = props;

    const timeElapsedPercentage = (timeElapsed / maxTime) * 100;

    const timeElapsedStyles =
        orientation === 'vertical'
            ? {
                  height: `${timeElapsedPercentage}%`,
              }
            : {
                  width: `${timeElapsedPercentage}%`,
              };

    const timerClasses = classNames({
        timer: true,
        'timer--horizontal': orientation === 'horizontal',
    });

    const timeElapsedClasses = classNames({
        'timer__time-elapsed': true,
        'timer__time-elapsed--horizontal': orientation === 'horizontal',
    });

    const label =
        countUp === true
            ? timeElapsed + 'seconds waiting'
            : timeElapsed + 'seconds remaining';

    return (
        <div className={timerClasses}>
            <span
                className={timeElapsedClasses}
                style={timeElapsedStyles}
                role="timer"
                aria-live={!countUp ? 'polite' : null}
                aria-label={label}
            />
        </div>
    );
};

Timer.defaultProps = {
    orientation: 'vertical',
    countUp: false,
};

Timer.propTypes = {
    timeElapsed: PropTypes.number.isRequired,
    maxTime: PropTypes.number.isRequired,
    orientation: PropTypes.oneOf(['vertical', 'horizontal']),
    countUp: PropTypes.bool,
};

export { Timer };
